// A parrot, modelled facing +X: a vivid body in one of four plumages, a hooked
// beak and a long tail. Ported 1:1 from age-of-mcp's classic parrot.ts, restoring
// its per-variant plumage table.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

const PLUMES = [
  ["#e23b3b", "#f4c430"], // scarlet macaw
  ["#2e8b57", "#f4c430"], // green
  ["#2966c9", "#f4c430"], // blue
  ["#e8742a", "#c4302a"], // orange
];

function partsFor(v: number): Part[] {
  const [body, wing] = PLUMES[v % PLUMES.length]!;
  return [
    { geometry: new THREE.IcosahedronGeometry(0.03, 0), color: body!,
      position: [0, 0.03, 0], scale: [1.3, 1.1, 0.9] },             // body
    { geometry: new THREE.IcosahedronGeometry(0.02, 0), color: body!,
      position: [0.04, 0.055, 0] },                                  // head
    { geometry: new THREE.ConeGeometry(0.011, 0.022, 4), color: "#2a2a2a",
      position: [0.062, 0.05, 0], rotation: [0, 0, -1.2] },          // hooked beak
    { geometry: new THREE.IcosahedronGeometry(0.016, 0), color: wing!,
      position: [-0.005, 0.03, 0.026], scale: [1, 1.4, 0.4] },       // wing
    { geometry: new THREE.IcosahedronGeometry(0.016, 0), color: wing!,
      position: [-0.005, 0.03, -0.026], scale: [1, 1.4, 0.4] },
    { geometry: new THREE.ConeGeometry(0.012, 0.07, 4), color: wing!,
      position: [-0.06, 0.03, 0], rotation: [0, 0, Math.PI / 2], scale: [1, 1, 0.4] }, // tail
  ];
}

export const parrot = defineModel({
  id: "parrot",
  batchId: "standard",
  name: "Parrot",
  tags: ["creature","parrot","low-poly","age-of-mcp","classic"],
  summary: "Low-poly parrot.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.07,
  variants: [
    { id: "variant-0", label: "Variant 1", parts: () => partsFor(0) },
    { id: "variant-1", label: "Variant 2", parts: () => partsFor(1) },
    { id: "variant-2", label: "Variant 3", parts: () => partsFor(2) },
    { id: "variant-3", label: "Variant 4", parts: () => partsFor(3) },
  ],
  animations: [],
});
